import { setLocale } from 'yup';

const initLocale = () =>
  setLocale({
    mixed: {
      required: 'FIELD_CANNOT_BE_EMPTY',
    },
  });

initLocale();

export { initLocale };
